/**
 * Shared Ajax add-to-cart: parse Shopify errors, one silent retry, logging.
 */
(function () {
  'use strict';

  if (!window.theme) window.theme = {};
  var theme = window.theme;

  var AUTO_RETRY_MS = 700;
  var GENERIC_MSG = 'Something went wrong on our end. Please try again.';
  var IN_APP_HINT = 'Having trouble? Try opening this page in Chrome or Safari.';

  function isInAppBrowser() {
    var ua = String(navigator.userAgent || '') + ' ' + String(navigator.vendor || '');
    return /Instagram|FBAN|FBAV|FB_IAB|FBOS|TikTok|musical_ly|BytedanceWebview|TTWebView/i.test(ua);
  }

  function parseBody(jqXHR) {
    if (!jqXHR) return null;
    var text = jqXHR.responseText;
    if (text == null || text === '') return null;
    if (typeof text === 'object') return text;
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  function customerMessage(body) {
    if (!body || typeof body !== 'object') return '';
    var desc = body.description;
    if (desc && String(desc).trim() && String(desc).trim() !== 'Cart Error') {
      return String(desc).trim();
    }
    var msg = body.message;
    if (msg && String(msg).trim() && String(msg).trim() !== 'Cart Error') {
      return String(msg).trim();
    }
    return '';
  }

  function isRetryable(parsed) {
    if (!parsed) return true;
    var status = parsed.status;
    var ts = parsed.textStatus || '';
    if (ts === 'timeout' || ts === 'abort') return true;
    if (status === 0 || status === 408 || status === 429 || status >= 500) return true;
    if (parsed.message && (status === 422 || status === 404)) return false;
    if (parsed.message && status >= 400 && status < 500) return false;
    if (!parsed.message) return true;
    return false;
  }

  function parseError(jqXHR, textStatus) {
    var status = jqXHR && typeof jqXHR.status === 'number' ? jqXHR.status : 0;
    var parsed = {
      status: status,
      textStatus: textStatus || '',
      message: customerMessage(parseBody(jqXHR)),
      retryable: false
    };
    parsed.retryable = isRetryable(parsed);
    return parsed;
  }

  function logError(parsed, surface, attempt, inApp) {
    try {
      console.warn('[ATC]', {
        surface: surface || '',
        status: parsed.status,
        retryable: !!parsed.retryable,
        attempt: attempt,
        inApp: !!inApp,
        textStatus: parsed.textStatus
      });
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'atc_error',
        atc_surface: surface || '',
        atc_status: parsed.status,
        atc_retryable: !!parsed.retryable,
        atc_attempt: attempt,
        atc_in_app: !!inApp
      });
    } catch (e2) {}
  }

  function addItem(id, qty, properties, opts) {
    opts = opts || {};
    var surface = opts.surface || '';
    var allowAutoRetry = opts.autoRetry !== false;
    var attempt = 0;

    function failOpen(parsed, extra) {
      if (opts.error) opts.error(parsed, extra || {});
    }

    function run() {
      attempt += 1;
      if (typeof CartJS === 'undefined') {
        failOpen(
          { status: 0, textStatus: 'no-cartjs', message: '', retryable: false },
          { retry: null, inApp: isInAppBrowser() }
        );
        return;
      }

      CartJS.addItem(id, qty, properties || {}, {
        success: function (data, textStatus, jqXHR) {
          if (opts.success) opts.success(data, textStatus, jqXHR);
        },
        error: function (jqXHR, textStatus) {
          var parsed = parseError(jqXHR, textStatus);
          var inApp = isInAppBrowser();
          logError(parsed, surface, attempt, inApp);

          if (allowAutoRetry && parsed.retryable && attempt === 1) {
            window.setTimeout(run, AUTO_RETRY_MS);
            return;
          }

          var retryFn = null;
          if (parsed.retryable) {
            retryFn = function () {
              addItem(id, qty, properties, {
                surface: surface,
                autoRetry: false,
                success: opts.success,
                error: opts.error
              });
            };
          }

          failOpen(parsed, { retry: retryFn, inApp: inApp });
        }
      });
    }

    run();
  }

  function presentError(parsed, extra) {
    extra = extra || {};
    parsed = parsed || { message: '', retryable: true, status: 0 };
    var hasShopify = !!parsed.message;
    var message = extra.displayMessage || (hasShopify ? parsed.message : GENERIC_MSG);
    var retryFn = extra.retry;
    var retryable = typeof retryFn === 'function';
    var hint = !hasShopify && extra.inApp ? IN_APP_HINT : '';

    if (window.theme && theme.CartDrawer && theme.CartDrawer.isEnabled && theme.CartDrawer.showError) {
      theme.CartDrawer.showError(message, {
        retry: retryable ? retryFn : null,
        hint: hint,
        retryable: retryable
      });
      return;
    }

    if (window.jQuery && $('#errorDrawer').length) {
      $('.error-message').text(message);
      $('body').addClass('loading showOverly');
      $('#errorDrawer').fadeIn(500);
      return;
    }

    window.alert(message);
  }

  theme.CartAdd = {
    parseError: parseError,
    isRetryable: isRetryable,
    addItem: addItem,
    presentError: presentError,
    isInAppBrowser: isInAppBrowser,
    GENERIC_MSG: GENERIC_MSG,
    IN_APP_HINT: IN_APP_HINT
  };
})();
